/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum RoutesAliases {
  BREADCRUMB_0 = 'breadcrumb-0',
  FRAGMENT_0 = 'fragment-0',
  FRAGMENT_1 = 'fragment-1',
  FRAGMENT_2 = 'fragment-2',
  FRAGMENT_3 = 'fragment-3',
  FRAGMENT_4 = 'fragment-4',
  FRAGMENT_5 = 'fragment-5',
  FRAGMENT_6 = 'fragment-6',
  FRAGMENT_7 = 'fragment-7',
  FRAGMENT_8 = 'fragment-8',
  FRAGMENT_9 = 'fragment-9',
  FRAGMENT_10 = 'fragment-10',
  FRAGMENT_11 = 'fragment-11',
  FRAGMENT_12 = 'fragment-12',
  FRAGMENT_13 = 'fragment-13',
  FRAGMENT_14 = 'fragment-14',
  FRAGMENT_15 = 'fragment-15',
  FRAGMENT_16 = 'fragment-16',
  FRAGMENT_17 = 'fragment-17',
  FRAGMENT_18 = 'fragment-18',
  FRAGMENT_19 = 'fragment-19',
  FRAGMENT_CHAMADOS = 'fragment-chamados',
  FRAGMENT_DEATLHES_CHAMADO = 'fragment-deatlhes-chamado',
  FRAGMENT_DETALHES_MENSAGEM = 'fragment-detalhes-mensagem',
  FRAGMENT_MENSAGENS = 'fragment-mensagens',
  FRAGMENT_NOVO_CHAMADO = 'fragment-novo-chamado',
  FRAGMENT_PRIVACY = 'fragment-privacy',
  FRAGMENT_TIPO_CHAMADO = 'fragment-tipo-chamado',
  LAYOUT_ROUTES = 'layout-routes',
  ROUTE_CHAMADOS = 'route-chamados',
  ROUTE_CONSENTIMENTOS = 'route-consentimentos',
  ROUTE_DADOS_CONTRATO = 'route-dados-contrato',
  ROUTE_DADOS_PESSOAIS = 'route-dados-pessoais',
  ROUTE_DASHBOARD = 'route-dashboard',
  ROUTE_DEATLHES_CHAMADO = 'route-deatlhes-chamado',
  ROUTE_DETALHES_AUTORIZACAO = 'route-detalhes-autorizacao',
  ROUTE_DETALHES_MENSAGEM = 'route-detalhes-mensagem',
  ROUTE_DETALHES_REQUISICAO = 'route-detalhes-requisicao',
  ROUTE_DETALHES_REQUISICAO_AUTORIZACAO = 'route-detalhes-requisicao-autorizacao',
  ROUTE_DINAMICO = 'route-dinamico',
  ROUTE_HISTORICO_AUTORIZACOES = 'route-historico-autorizacoes',
  ROUTE_HISTORICO_CANCELAMENTOS = 'route-historico-cancelamentos',
  ROUTE_HISTORICO_PARTICIPACOES = 'route-historico-participacoes',
  ROUTE_HISTORICO_PROTOCOLOS = 'route-historico-protocolos',
  ROUTE_HISTORICO_REQUISICOES = 'route-historico-requisicoes',
  ROUTE_INFORMACOES_ADICIONAIS = 'route-informacoes-adicionais',
  ROUTE_MENSAGENS = 'route-mensagens',
  ROUTE_MENSALIDADES = 'route-mensalidades',
  ROUTE_MEUS_DADOS = 'route-meus-dados',
  ROUTE_NOVO_CHAMADO = 'route-novo-chamado',
  ROUTE_PRIVACY = 'route-privacy',
  ROUTE_RECEBER_BOLETOS_EMAIL = 'route-receber-boletos-email',
  ROUTE_SOLICITAR_CANCELAMENTO = 'route-solicitar-cancelamento',
  ROUTE_SOLICITAR_PARTICIPACAO = 'route-solicitar-participacao',
  ROUTE_SOLICITAR_VIA = 'route-solicitar-via',
  ROUTE_TIPO_CHAMADO = 'route-tipo-chamado',
}
export { RoutesAliases };
